import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=39ba45be&scoped=true&"
import script from "./Body.vue?vue&type=script&lang=js&"
export * from "./Body.vue?vue&type=script&lang=js&"
import style0 from "./Body.vue?vue&type=style&index=0&id=39ba45be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ba45be",
  null
  
)

export default component.exports